var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._g(_vm._b({class:[
    'fu-speed-dial-button',
    'fu-speed-dial-button--' + _vm.props.type,
    {
      'fu-speed-dial-button--rotate': _vm.props.rotate,
      'is-disabled': _vm.props.disabled,
      'is-active': _vm.props.active,
    },
    _vm.data.class
  ],style:({
    width: _vm.props.size,
    height: _vm.props.size,
    backgroundColor:_vm.props.backgroundColor,
    color:_vm.props.color,
    fontSize:_vm.props.fontSize
  })},'div',_vm.data.attrs,false),_vm.data.on),[_vm._t("default",[_c('i',{class:_vm.props.icon})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }